
export const entrepreneursAgeRangeChartOptions = {
  plugins: {
    legend: {
      position: "bottom"
    },
    datalabels: {
      color: "#000"
    }
  },
  scales: {
  },
  maintainAspectRatio: false
};
